(function () {
    'use strict';

    angular
        .module('procedureControllers')
        .controller('ProcedureController', Controller);

    Controller.$inject = ['topBarService'];

    function Controller(topBarService) {
        // topBarService.setTitleAndIcon('Procedures', 'fa fa-book');
        topBarService.setTopBar({
            title1: 'Procedures',
            icon1: 'fa fa-book'
        });
    }
})();